import styled from 'styled-components';
import PropTypes from 'prop-types';
import Label from '../../Label';

const FormControl = styled.div`
  margin-bottom: 40px;

  ${Label} {
    display: ${props => (props.inline ? 'inline-block' : 'block')};
    margin-bottom: ${props => (props.inline ? 0 : '5px')};
    margin-right: ${props => (props.inline ? '10px' : 0)};
  }
`;

FormControl.defaultProps = {
  inline: false,
};

FormControl.propTypes = {
  inline: PropTypes.bool,
};

export default FormControl;
